module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bottle2-c5f8bf2a04c9011cb0b4d08da7822215.svg";